import { withBase } from './base-path'

export const isReloadNavigation = (): boolean => {
  try {
    const entries = performance.getEntriesByType(
      'navigation'
    ) as PerformanceNavigationTiming[]
    if (entries && entries.length > 0) {
      return entries[0].type === 'reload'
    }
    const legacy = (performance as any).navigation
    return legacy && legacy.type === 1 // 1 indicates reload
  } catch {
    return false
  }
}

export const navigateReplace = (path: string): void => {
  const target = withBase(path)
  if (window.location.pathname !== target) {
    window.history.replaceState(
      {},
      '',
      target + window.location.search + window.location.hash
    )
    window.dispatchEvent(new PopStateEvent('popstate'))
  }
}

export const navigatePush = (path: string): void => {
  const target = withBase(path)
  window.history.pushState(
    {},
    '',
    target + window.location.search + window.location.hash
  )
  window.dispatchEvent(new PopStateEvent('popstate'))
}

export const maybeRedirectToIndexHtmlIfReload = (
  shouldRedirect: boolean
): void => {
  if (isReloadNavigation() && shouldRedirect) {
    navigateReplace('index.html')
  }
}
